import { Controller } from "@hotwired/stimulus"

// Drives the contacts FILTERS panel in the side nav. The contacts datatable
// lives in a sibling DOM subtree (the content column), so these selects can't
// be Stimulus filter-targets of it. Changing a filter navigates with the chosen
// param; the datatable reads it from the URL on load and scopes the list.
export default class extends Controller {
  apply(event) {
    const select = event.target
    const url = new URL(window.location.href)
    if (select.value === "" || select.value == null) {
      url.searchParams.delete(select.name)
    } else {
      url.searchParams.set(select.name, select.value)
    }
    window.location.assign(url.toString())
  }
}
